<template>
  <div class="cts_box stand-by">
    <h2>{{ moment(current_user.join_at, 'YYYY年M') }}月期生の入塾手続きありがとうございました。</h2>
    <div class="inner">
      <h3>月例会・研修会にお申し込みください</h3>
      <p>
        入塾日前に「月例会」「研修会」にお申し込みが可能です。「イベント申し込み」よりお申し込みください。
        定員になり次第締切となりますので、ぜひお早目にお申し込みください。
      </p>
      <h3 class="blue">※東洋経済新報社・会社四季報オンラインのオプションをお申込みの方</h3>
      <p class="mb0">
        会社四季報オンラインのオプションIDも、{{ moment(current_user.join_at, 'YYYY年M月D日') }}から利用可能となります。入塾日以降にID／仮パスワードを当マイページ内でご確認ください。
      </p>
    </div>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries]
}
</script>